import { ScreenSize } from '@core/models';

export const isMobile = (screenSize: ScreenSize) => screenSize.isMobile;
export const isTablet = (screenSize: ScreenSize) => screenSize.isTablet;
export const isLaptop = (screenSize: ScreenSize) => screenSize.isLaptop;
export const isDesktop = (screenSize: ScreenSize) => screenSize.isDesktop;
export const isXLarge = (screenSize: ScreenSize) => screenSize.isXLarge;

export const isSmallScreens = (screenSize: ScreenSize) =>
  isMobile(screenSize) || isTablet(screenSize);

export const isAllSizesExceptMobile = (screenSize: ScreenSize) =>
  isTablet(screenSize) || isLaptop(screenSize) || isDesktop(screenSize) || isXLarge(screenSize);

export const isLargeScreens = (screenSize: ScreenSize) =>
  isLaptop(screenSize) || isDesktop(screenSize) || isXLarge(screenSize);
